import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var EventsIcon = function EventsIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "EventsIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: [jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M11.166 7.446a.784.784 0 0 1 0 1.108l-3.134 3.134a.784.784 0 0 1-1.108 0l-1.568-1.567a.784.784 0 1 1 1.109-1.108l1.013 1.013 2.58-2.58a.784.784 0 0 1 1.108 0",
      clipRule: "evenodd"
    }), jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M5.91 1c.404 0 .732.327.732.731v.773h2.716v-.773a.731.731 0 0 1 1.463 0v.773h1.801c.271 0 .515 0 .718.016.218.017.45.056.68.168.331.162.606.424.78.753.123.23.165.464.183.679.017.198.017.436.017.694v7.876c0 .258 0 .496-.017.695-.018.215-.06.449-.182.679-.175.328-.45.59-.781.752-.23.112-.462.151-.68.168-.203.016-.447.016-.718.016H3.378c-.271 0-.515 0-.718-.016a1.8 1.8 0 0 1-.68-.168 1.76 1.76 0 0 1-.78-.752 1.7 1.7 0 0 1-.183-.68C1 13.187 1 12.949 1 12.69V4.814c0-.258 0-.496.017-.694.018-.215.06-.45.182-.68.175-.328.45-.59.781-.752.23-.112.462-.15.68-.168.203-.016.447-.016.718-.016h1.801v-.773c0-.404.328-.731.731-.731m-.73 2.967H3.402c-.304 0-.49 0-.629.012a.6.6 0 0 0-.15.023.3.3 0 0 0-.131.122.6.6 0 0 0-.019.12c-.01.129-.011.303-.011.597v7.823c0 .293 0 .468.011.597a.6.6 0 0 0 .019.12c.026.048.07.092.13.121a.6.6 0 0 0 .151.024c.139.01.325.011.629.011h9.194c.304 0 .49 0 .629-.011a.6.6 0 0 0 .15-.024.3.3 0 0 0 .131-.121.6.6 0 0 0 .019-.12c.01-.13.011-.304.011-.597V4.84c0-.294 0-.468-.011-.597a.6.6 0 0 0-.019-.12.3.3 0 0 0-.13-.122.6.6 0 0 0-.151-.023 9 9 0 0 0-.629-.012h-1.776v1.275a.731.731 0 1 1-1.463 0V3.967H6.642v1.275a.731.731 0 1 1-1.463 0zm8.326.154.001.003zm0 9.262.001-.002zm-11.013-.002v.002zm0-9.257V4.12z",
      clipRule: "evenodd"
    })]
  }));
};

export { EventsIcon };
